<template>
  <div>
    <Buscador v-if="show_buscador" @search="get_tarjetas_fidelidad_vendidas"/>
    <!-- Tabla de tarjetas fidelidad -->
    <v-data-table
        :headers="tabla.headers"
        :items="tabla.tarjetas_fidelidad"
        :options.sync="tabla.options"
        :server-items-length="tabla.count"
        :fixed-header="true"
        class="elevation-3"
        calculate-widths
        :footer-props="{ itemsPerPageOptions: [5, 10, 20, 50], itemsPerPageText: $t('Registros por página') }"
        :no-data-text="$t('No hay datos')"
        :no-results-text="$t('No hay datos')"
    >
      <template v-slot:item="{ item }">
        <tr @click="item_selected(item)" :class="{'pointer': true,  'selected': !show_actions && (current_selected && current_selected.id == item.id), 'red--text text-decoration-line-through': item.is_caducada}">
          <td>{{ item.numeracion }}</td>
          <td>{{ item.fecha_compra | moment('DD/MM/YYYY') }}</td>
          <td>{{ item.descripcion }}</td>
          <td>{{ item.importe_usado | money }}</td>
          <td>{{ item.importe_restante | money }}</td>
          <td>{{ item.descuento_servicios }}%</td>
          <td>{{ item.descuento_productos }}%</td>
          <td>
            <span v-if="item.fecha_caducidad"> {{ item.fecha_caducidad | moment('DD/MM/YYYY') }} </span>
            <span v-else>{{ $t('Sin caducidad') }}</span>
          </td>
          <td v-if="show_actions">
            <v-menu bottom offset-y>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" small color="primary">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item class="pointer" @click="$emit('on_click_traspasar_saldo', {
                  'tarjeta_fidelidad_seleccionada': item,
                  'tarjetas_fidelidad': tabla.tarjetas_fidelidad
                })"
                             v-if="!item.is_caducada"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-cash-multiple</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ $t("Traspasar saldo") }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item @click="$emit('on_click_imprimir', item)">
                  <v-list-item-icon>
                    <v-icon>mdi-printer</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ $t("Imprimir") }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item @click="$emit('on_click_ver_movimientos', item)">
                  <v-list-item-icon>
                    <v-icon>mdi-history</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ $t("Ver historial") }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="$store.state.auth.user.tipo_empleado === 'admin'"
                             @click="$emit('on_click_edit', item)">
                  <v-list-item-icon>
                    <v-icon>mdi-pencil</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ $t('Editar') }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'TablaTarjetasFidelidadVendidas',
  props: {
    // Filtros para realizar la búsqueda
    selected_filters: {
      type: Object,
      default: {},
      required: true
    },
    show_buscador: {
      type: Boolean,
      default: false
    },
    show_actions: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    tabla: {
      tarjetas_fidelidad: [],
      count: 0,
      headers: [],
      filtros: {},
      options: {
        itemsPerPage: localStorage.getItem('itemsPerPage') ? parseInt(localStorage.getItem('itemsPerPage')) :  10
      }
    },
    current_selected: null
  }),

  methods: {
    /**
     * Recupera las tarjetas fidelidad de la api
     */
    async get_tarjetas_fidelidad_vendidas(search = null) {
      if(search)
        this.tabla.filtros['search'] = search
      let filtros = { ...this.tabla.filtros, ...this.selected_filters }

      filtros['ordering']= filtros['ordering'] === 'descripcion'?'tarjeta_fidelidad__nombre':filtros['ordering']
      filtros['ordering']= filtros['ordering'] === '-descripcion'?'-tarjeta_fidelidad__nombre':filtros['ordering']

      filtros['ordering']= filtros['ordering'] === 'caducidad_meses'?'fecha_caducidad':filtros['ordering']
      filtros['ordering']= filtros['ordering'] === '-caducidad_meses'?'-fecha_caducidad':filtros['ordering']

      const response = await this.$store.dispatch("tarjeta_fidelidad/get_tarjetas_fidelidad_vendidas", {
        params: filtros
      });

      this.tabla.tarjetas_fidelidad = response.results;
      this.tabla.count = response.count;
    },

    item_selected(tarjeta){
      this.current_selected = tarjeta
      this.$emit('on_click_selected', tarjeta)
    }
  },

  watch: {
    'tabla.options': {
      handler(value, oldValue){
        if(value.itemsPerPage !== oldValue.itemsPerPage){
          try{
            localStorage.setItem('itemsPerPage', value.itemsPerPage)
          }catch (e){}
        }
        this.tabla.filtros['limit'] = value.itemsPerPage
        this.tabla.filtros['offset'] = ((value.page - 1) * value.itemsPerPage)
        if (value.sortBy.length) {
          let desc = value.sortDesc[0] === true ? '-' : ''
          this.tabla.filtros['ordering'] = `${desc}${value.sortBy[0]
              .split(".")
              .join("__")}`;
        }
        this.get_tarjetas_fidelidad_vendidas()
      },
    },
  },

  mounted() {
    this.tabla.headers = [
      { text: this.$t("Numeración"), value: "numeracion", class: "primary white--text" },
      { text: this.$t("Fecha compra"), value: "fecha_compra", class: "primary white--text"},
      { text: this.$t("Descripción"), value: "descripcion", class: "primary white--text" },
      { text: this.$t("Importe usado"), value: "importe_usado", class: "primary white--text" },
      { text: this.$t("Importe restante"), value: "importe_restante", class: "primary white--text", sortable: false},
      { text: this.$t("Descuento servicios"), value: "descuento_servicios", class: "primary white--text" },
      { text: this.$t("Descuento productos"), value: "descuento_productos", class: "primary white--text" },
      { text: this.$t("Fecha caducidad"), value: "caducidad_meses", class: "primary white--text" },
      { text: "", value: "actions", class: "primary white--text", sortable: false, align: "right", width: "10px" }
    ]

    // Si no es editable (caso venta) eliminamos la columna de acciones
    if(!this.show_actions) this.tabla.headers.pop()
  },
}
</script>


<style lang="scss" scoped>
.selected {
  background-color: grey !important;
  color: white !important;

  &:hover {
    background-color: grey !important;
    color: white !important;
  }

  td {
    background-color: grey !important;
    color: white !important;

    &:hover {
      background-color: grey !important;
      color: white !important;
    }
  }
}
</style>
